import {
  HOST,
  LMS_BACK_URL,
  API_REST_URL,
  SECRET_WORD,
} from 'config/variables';
import { apiClient } from 'config/api';

export type CustomHeaders = {
  [key: string]: string | undefined;
};

export const post = async (
  endpoint: string,
  data?: unknown,
): Promise<unknown> => {
  try {
    const URL = `${API_REST_URL}/${endpoint}`;
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'api-secret-key': SECRET_WORD,
      },
      body: JSON.stringify(data as unknown),
    });
    return await res.json();
  } catch (error) {
    return error;
  }
};

export type GenerateCustomTokenData =
  | string
  | { tokenId: string; id?: string; email?: string };

export const generateCustomToken = async (
  id: string,
  tenantId?: string,
): Promise<GenerateCustomTokenData | null> => {
  const response = (await post('authentication/generate-custom-token', {
    id,
    tenantId: tenantId,
  }).catch(() => null)) as { status?: string; data?: GenerateCustomTokenData } | null;

  return response?.data ?? null;
};

interface CognitoSSOResponse {
  ssoToken: string;
  username: string;
  userPoolId: string;
  clientId: string;
  region: string;
  userAuthId: string;
  client_id: string;
}

export const generateCustomTokenCognito = async (
  id: string,
  tenantId?: string,
): Promise<CognitoSSOResponse | null> => {
  try {
    const response: any = await post('cognito/generate-custom-token', { id, tenantId: tenantId });

    // Asumiendo que la respuesta tiene la estructura { status: string, data: CognitoSSOResponse }
    if (response && response.data) {
      return response.data as CognitoSSOResponse;
    }
    return null;
  } catch (error) {
    console.error('Error generating Cognito token:', error);
    return null;
  }
};

export const externalApiKey = async (
  hostUrl: string,
  apiKey?: string,
  method: 'GET' | 'POST' = 'GET',
  tokenBodyField?: string,
  token?: string,
  customHeaders?: CustomHeaders,
): Promise<unknown> => {
  try {
    const URL = `${hostUrl}`;
    const res = await fetch(URL, {
      method,
      headers: {
        ...(method === 'GET' && { 'Content-Type': 'application/json' }),
        ...(apiKey &&
          !customHeaders?.['Api-Key'] && {
            Authorization: `API_SECRET ${apiKey}`,
          }),
        ...(customHeaders ?? {}), // Agregar encabezados personalizados
      },
      body: tokenBodyField
        ? JSON.stringify({ [tokenBodyField]: token })
        : undefined,
    });

    return await res.json();
  } catch (error) {
    return error;
  }
};

export const getUserBySubdomain = async (
  email: string,
  subdomain: string,
  token: string,
) => {
  return await apiClient(
    API_REST_URL,
    'GET',
    `/users/user-by-subdomain/${encodeURIComponent(email)}/${encodeURIComponent(
      subdomain,
    )}`,
    undefined,
    { Authorization: `Bearer ${token}` },
  );
};
